module.exports = __webpack_public_path__ + "img/step1-b.380ab6d2.png";